import { render, staticRenderFns } from "./ActivatePermissionButton.vue?vue&type=template&id=2bf8be7f"
import script from "./ActivatePermissionButton.vue?vue&type=script&lang=js"
export * from "./ActivatePermissionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports